import {
  observable,
  action
} from 'mobx'
// import {store} from '../store.index';

class getStream {
  @observable fileName = null
  // 保存
  @action setFileName(fileName) {
    this.fileName = fileName
  }
  // 获取pdf文本流
  @action async getFileBlob() {
    const pdfDoc = await window.pdfui.getCurrentPDFDoc();
    this.setFileName(pdfDoc.info.fileName)
    let bufferArray = [];
    return pdfDoc.getStream(({ arrayBuffer}) => {
      bufferArray.push(arrayBuffer);
    })
    .then((size) => {
      console.log("The total size of the stream", size);
      return new Blob(bufferArray, { type: "application/pdf" });
    });
  }
}

export default getStream;
